import React from 'react';

import clsx from 'clsx';
import TextareaAutosize, { TextareaAutosizeProps } from 'react-textarea-autosize';

import { isValueSet } from '@utils/guards';

import styles from '@components/common/StyledInput/StyledInput.module.scss';

type ClassKey = 'root' | 'label' | 'input' | 'wrapper' | 'placeholder' | 'hintMessage';

type StyledTextAreaProps = TextareaAutosizeProps & {
    label?: string;
    hintMessage?: string;
    hasError?: boolean;
    isResizable?: boolean;
    isKeepHintPlace?: boolean;
    classes?: Classes<ClassKey>;
};

export const StyledTextArea = React.forwardRef<HTMLTextAreaElement, StyledTextAreaProps>(
    (props, ref) => {
        const {
            label,
            hintMessage,
            className,
            placeholder,
            classes,
            hasError = false,
            isResizable = false,
            isKeepHintPlace = false,
            disabled: isDisabled,
            ...restProps
        } = props;

        return (
            <div className={clsx(styles.root, classes?.root)}>
                <label
                    className={clsx(
                        styles.wrapper,
                        isDisabled && styles.isDisabled,
                        hasError && styles.hasError,
                        classes?.wrapper,
                    )}
                >
                    <TextareaAutosize
                        ref={ref}
                        placeholder={
                            isValueSet(placeholder) && placeholder.length > 0 ? placeholder : label
                        }
                        {...restProps}
                        disabled={isDisabled}
                        className={clsx(
                            styles.input,
                            styles.textarea,
                            isResizable && styles.isResizable,
                            hasError && styles.hasError,
                            isValueSet(label) && styles.hasLabel,
                            className,
                            classes?.input,
                        )}
                    />
                    {isValueSet(label) && (
                        <span
                            className={clsx(styles.label, styles.isWhiteBackground, classes?.label)}
                        >
                            {label}
                        </span>
                    )}
                </label>

                <p
                    className={clsx(
                        styles.hintMessage,
                        isValueSet(hintMessage) && styles.isVisible,
                        hasError && styles.isErrorMessage,
                        isKeepHintPlace && styles.isKeepHintSpace,
                        classes?.hintMessage,
                    )}
                >
                    {hintMessage}
                </p>
            </div>
        );
    },
);
